<template>

    <div class="footer-wrapper" v-if=" !isShowMenu() ">

        <div v-for=" ( route, routeKey ) in relevantRoutes "
            :class=" ( currentRoute.name == route.name ) ? ( currentLocation.merchantId == merchantIdCrocante ? 'icon-active-crocante' : 'icon-active' ) : 'icon-gray' "
            @click=" navTo( route.name ) "
            :key=" routeKey ">
            <font-awesome-icon class="footer-icon" :icon=" route.icon " v-if=" validate(currentRoute.name) "/>
        </div>
        <div @click=" toggleOverflow() " class="icon-gray">

            <font-awesome-icon class="footer-icon" icon="ellipsis-v" />
        </div>
    </div>
</template>

<script>

    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
    import { mapGetters, mapActions } from 'vuex';

    export default {

        name: 'footer-bar',
        computed: {

            ...mapGetters({

                currentRoute        : 'currentRoute',
                merchantSlug        : 'merchant/merchantSlug',
                routes              : 'nav/routes',
                isAuth              : 'auth/isAuth',
                currentLocation     : 'merchant/currentLocation',
                merchantIdCrocante  : 'merchantIdCrocante',
            }),
            relevantRoutes: function(){

                let route = this.routes.filter( route => {

                    return route.mainRoute;
                })[ 0 ];

                let routes = route.children.filter( route => {

                    return route.onFooter;
                });

                return routes.sort( ( a, b ) => a.displaySequence - b.displaySequence );
            }
        },
        methods: {

            ...mapActions({

                toggleOverflow: 'nav/toggleOverflow'
            }),
            isShowMenu(){
                return this.currentRoute.name == 'not-found' || this.currentRoute.name == 'merchant-location' || this.currentRoute.name == 'signin';
            },
            navTo( destination ){
                
                if( this.currentRoute.name == 'merchant-location' || this.currentRoute.name == 'merchant-delivery' || this.currentRoute.name == 'delivery-address' || this.currentRoute.name == 'delivery-pickup-spot' || this.currentRoute.name == 'delivery-building' || this.currentRoute.name == 'full-delivery' ){
                    console.log('currentRoute ' + this.currentRoute.name);
                } else if ( this.currentRoute.name == 'home' && !this.isAuth ) {
                    console.log('currentRoute home and without login ' + this.currentRoute.name);
                } else {
                    this.$store.dispatch( 'nav/closeOverflow' ); //close OverFlowMenu when not is used
                    this.$store.dispatch( 'orderMenu/clearState', true );
                    this.$router.push({

                        name: destination,
                        params : { slug : this.merchantSlug }
                    });
                }
            },
            validate( router ){
                
                if( ( router != 'not-found') && ( router != 'merchant-location') && (router != 'merchant-delivery') && (router != 'delivery-address') && (router != 'delivery-pickup-spot') && (router != 'delivery-building') && (router != 'full-delivery') ){
                    return true;
                } else {
                    return false;
                }
            }
        },
        components: {

            FontAwesomeIcon
        },
    }
</script>

<style scoped>

    .footer-wrapper {

        display: flex;
        align-items: center;
        justify-content: space-between;

        position: fixed;
        border-top: 1px solid rgba( 0, 0, 0, 0.2 );
        width: 100%;
        bottom: 0px;
        left: 0;
        right: 0;
        height: 65px;
        background-color: white;
        padding: 0px 25px;
        z-index: 450;
        box-shadow: 0px -6px 25px -7px rgba( 0, 0, 0, 0.5 );
    }

    .footer-wrapper > div {

        display: flex;
        align-items: center;
        justify-content: center;

        width: 35px;
        height: 35px;
    }

    .footer-icon {

        font-size: 22px;
        cursor: pointer;
    }

    .icon-active {

        color: #e10b00;
    }

    .icon-active-crocante {

        color: #DFEC72;
    }

    .icon-gray {
        color: gray
    }
</style>